import { PredictDictionaryIcon } from '../../assets';

export const tableHeight: number = 210;
export const REFERENCE_TYPE = 'reference';

export type ColumnDef = {
    field: string;
    headerName: string;
    width?: number;
    editable?: boolean;
    flex?: number;
    headerClassName?: string;
};

export const getColumns = (): ColumnDef[] => {
    return [
        {
            field: 'name',
            headerName: 'Dictionary Name',
            width: 150,
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
        },
        {
            field: 'description',
            headerName: 'Description',
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
        },
        {
            field: 'groupName',
            headerName: 'Dictionary Grouping',
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
        },
    ];
};

export const dictionaryConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'predict-dictionary': {
        imgSrc: PredictDictionaryIcon,
        headingText: 'Predict Dictionary',
        iconStyles: {
            width: '75.95px',
            height: '87.73px',
        },
    },
};
